import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { AssetLibrary } from "@/features/assets";

export const Route = createFileRoute("/_authenticated/org/assets")({
  component: AssetsPage,
});

/**
 * The SMM's shared folder of pre-approved images. Anything here is
 * immediately visible to the whole org, so nobody taking an image from it
 * ever has to wonder whether they are allowed to use it.
 */
function AssetsPage() {
  return (
    <div>
      <PageHeader
        eyebrow="Your team"
        title="Asset library"
        description="Logos, photos, and graphics approved for anyone posting on your organisation's behalf."
      />
      <AssetLibrary manage />
    </div>
  );
}
